import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-338ba1e3")

_pushScopeId("data-v-338ba1e3")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-info-circle",
  style: {"color":"grey"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("     ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2
  ]))
})